export const maxInitializationAttempts = 10;
